import { Recipe } from "@juicy/models";
import { useNavigation } from "@react-navigation/native";
import { Button, Card, Spinner } from "@ui-kitten/components";
import React, { useEffect, useState } from "react";
import { View } from "react-native";
import { apiService } from "../../App";
import { Container } from "../common/layout/Boxes";
import { ScreenLayout } from "../common/layout/ScreenLayout";
import { BottomTabNavigation } from "../navigation";
import { Description } from "./description";
import { RecipeHistory } from "./history";
import { RecipeListItem } from "./RecipeListItem";

interface RecipeShowScreenProps {
    recipeId: number;
}

export const RecipeShowScreen: React.FC<RecipeShowScreenProps> = ({ recipeId }) => {
    const navigation = useNavigation<BottomTabNavigation>();
    const [recipe, setRecipe] = useState<Recipe | null>(null);

    const handleSaveDescription = (description: string) => {
        if (recipe) {
            recipe.description = description;
            void apiService.recipe.edit(recipe);
        }
    };

    useEffect(() => {
        apiService.recipe
            .getById(recipeId)
            .then((data) => {
                setRecipe(data);
            })
            .catch(() => {
                /* */
            });
    }, [recipeId]);

    return (
        <View style={{ flex: 1 }}>
            <ScreenLayout scroll={true}>
                <Container>
                    {!recipe ? (
                        <View>
                            <Spinner />
                        </View>
                    ) : (
                        <View>
                            <RecipeListItem recipe={recipe} />
                            <Description description={recipe.description} onChange={handleSaveDescription} />
                            {recipe && recipe.history && <RecipeHistory recipe={recipe} />}
                        </View>
                    )}
                </Container>
            </ScreenLayout>
            {!!recipe && (
                <Card>
                    <Button
                        onPress={() => {
                            navigation.navigate("BatchStackScreen", {
                                screen: "BatchCreateScreen",
                                params: { recipeId: `${recipe.userId}-${recipe.id}-${recipe.version}` },
                            });
                        }}
                    >
                        Create Batch
                    </Button>
                </Card>
            )}
        </View>
    );
};
